import React, { createContext, useEffect, useState } from "react";

// Create a new context
export const MyContext = createContext();

const MyProvider = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  
  return (
    <MyContext.Provider
      value={{isSidebarOpen, setIsSidebarOpen }}
    >
      {children}
    </MyContext.Provider>
  );
};

export default MyProvider;